// extracted by mini-css-extract-plugin
export default {"colorTangelo":"#fc4c02","table":"TableLayout_table__HE+-A","back":"TableLayout_back__eMBMW","no-hover":"TableLayout_no-hover__gs9MT"};